import {WidgetType} from '@codemirror/view'

/** Renders an empty `span` element. `EmptySpanWidget` is a singleton and cannot be constructed. */
export const EmptySpanWidget = new (class extends WidgetType {
  toDOM() {
    return document.createElement('span')
  }

  override eq() {
    return true
  }
})()
